var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-items-center",class:!_vm.loggedIn?'footer': 'hidden-footer'},[(!_vm.loggedIn)?_c('login-form',{staticClass:"mx-5"}):_vm._e(),(!_vm.loggedIn)?_c('register-form'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }